import {
  Backdrop,
  Modal,
  Typography,
  Box,
  Button,
  useTheme,
  Fade,
} from '@mui/material';
import React from 'react';
import CustomButton from '../../components/CustomButton';
import { useCustomModalStyles } from './styles';
import ModalContentWrapper from '../ModalContentWrapper';

interface IProps {
  isModalOpen: boolean;
  handlePrimary: () => void;
  handleSecondary: () => void;
  primaryText: string;
  secondaryText: string;
  message: string;
  direction?: 'row' | 'column';
}

const CustomModal = ({
  message,
  primaryText,
  secondaryText,
  isModalOpen,
  handlePrimary,
  handleSecondary,
  direction = 'row',
}: IProps) => {
  const customModalStyles = useCustomModalStyles();
  const theme = useTheme();
  const isRowDirection = direction === 'row';

  return (
    <Modal
      open={isModalOpen}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 300,
        },
      }}>
      <Fade in={isModalOpen}>
        <div>
          <ModalContentWrapper>
            <Typography
              borderBottom={`1px solid ${theme.palette.divider}`}
              fontWeight={500}
              mb={isRowDirection ? '24px' : '12px'}
              fontSize="14px"
              textAlign="center"
              pb="12px">
              {message}
            </Typography>

            <Box alignItems="center" display="flex" flexDirection={direction}>
              <Button
                sx={{
                  ...customModalStyles.cancelButton,
                  marginRight: isRowDirection ? '8px' : 0,
                  marginBottom: isRowDirection ? 0 : '8px',
                }}
                variant="text"
                onClick={handleSecondary}>
                {secondaryText}
              </Button>

              <CustomButton
                style={{
                  ...customModalStyles.confirmButton,
                  marginLeft: isRowDirection ? '8px' : 0,
                }}
                handleClick={handlePrimary}>
                {primaryText}
              </CustomButton>
            </Box>
          </ModalContentWrapper>
        </div>
      </Fade>
    </Modal>
  );
};

export default CustomModal;
